import { useCallback, useEffect, useMemo, useState } from 'react';
import { warningAudio } from '../services/warningAudio';

export function useWarningAudio() {
  const [status, setStatus] = useState(warningAudio.status);
  useEffect(() => warningAudio.subscribe(setStatus), []);
  const initialize = useCallback(() => warningAudio.initialize(), []);
  const play = useCallback(() => warningAudio.play(), []);
  const test = useCallback(() => warningAudio.test(), []);
  const setMuted = useCallback((muted: boolean) => warningAudio.setMuted(muted), []);
  const dispose = useCallback(() => warningAudio.dispose(), []);
  return useMemo(() => ({
    status,
    initialize,
    play,
    test,
    setMuted,
    dispose
  }), [dispose, initialize, play, setMuted, status, test]);
}
